export enum ROLES {
  LEADER = 'Leader',
  MANAGER = 'Manager',
  USER = 'Guest',
}
